import './Links.scss';
import Links from './Links';

export default Links;
